// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/laravel-mix/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".h-toolbar-pa-0>div[data-v-7932d964]{padding:0}", "",{"version":3,"sources":["webpack://./resources/js/Sections/Order/Dialogs/Catalog/Toolbar/Categories.vue"],"names":[],"mappings":"AACA,qCACE,SAAF","sourcesContent":["\n.h-toolbar-pa-0 > div {\n  padding: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
